export default function WhatIsSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          {/* Image */}
          <div className="relative rounded-2xl overflow-hidden h-[320px] md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Minimal%20modern%20desk%20setup%20with%20laptop%20showing%20colorful%20spreadsheet%20charts%20and%20organized%20product%20data%20on%20screen%2C%20warm%20natural%20sunlight%20streaming%20through%20window%2C%20cream%20walls%20with%20subtle%20warmth%2C%20small%20succulent%20plant%20in%20terracotta%20pot%2C%20clean%20organized%20workspace%20with%20notebook%20and%20pen%2C%20editorial%20photography%20with%20soft%20warm%20tones%2C%20professional%20yet%20cozy%20atmosphere&width=800&height=600&seq=whatis-v2&orientation=landscape"
              alt="Vigorbuy Spreadsheet workspace"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-5">
              What Is <span className="text-primary-600">Vigorbuy Spreadsheet</span>?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              Vigorbuy Spreadsheet is a powerful product organization system that transforms how you discover and research products online. Instead of jumping between countless web pages, Vigorbuy Spreadsheet centralizes product information into clean, organized spreadsheets sorted by category.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              Whether you are looking for the latest <strong>Shoes</strong>, trending <strong>Hoodies</strong>, or essential <strong>Accessories</strong>, the Vigorbuy Spreadsheet system gives you a birds-eye view of available products with detailed information at your fingertips.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Think of Vigorbuy Spreadsheet as your personal shopping assistant — it organizes, categorizes, and presents product data in a way that makes comparison shopping fast, efficient, and actually enjoyable. No more endless scrolling through disorganized product pages.
            </p>

            <div className="grid grid-cols-2 gap-3">
              {[
                { icon: 'ri-speed-up-line', label: 'Fast Product Discovery' },
                { icon: 'ri-organization-chart', label: 'Organized Categories' },
                { icon: 'ri-compasses-2-line', label: 'Easy Comparison' },
                { icon: 'ri-shield-check-line', label: 'Verified Information' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-2 p-3 rounded-lg bg-primary-50/80">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${item.icon} text-base text-primary-600`}></i>
                  </div>
                  <span className="text-xs md:text-sm font-medium text-foreground-800">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}